/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { ResolveCodeParams } from '../_model/resolveCodeParams';
import type { SuccessBodyEnterCodeResult } from '../_model/successBodyEnterCodeResult';
import type { SuccessBodyResolveCodeResult } from '../_model/successBodyResolveCodeResult';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary RAW 문자열 코드를 CLASSROOM / BOARD / QUIZ 로 분류한다
 */
export const resolveCode = (
  params: ResolveCodeParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyResolveCodeResult>(
    { url: `/resolve-code`, method: 'GET', params, signal },
    options,
  );
};

export const getResolveCodeQueryKey = (params?: ResolveCodeParams) => {
  return [`/resolve-code`, ...(params ? [params] : [])] as const;
};

export const getResolveCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof resolveCode>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getResolveCodeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveCode>>> = ({
    signal,
  }) => resolveCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof resolveCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ResolveCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof resolveCode>>
>;
export type ResolveCodeQueryError = ErrorType<unknown>;

export function useResolveCode<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof resolveCode>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveCode>>,
          TError,
          Awaited<ReturnType<typeof resolveCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveCode<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof resolveCode>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveCode>>,
          TError,
          Awaited<ReturnType<typeof resolveCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveCode<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof resolveCode>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary RAW 문자열 코드를 CLASSROOM / BOARD / QUIZ 로 분류한다
 */

export function useResolveCode<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof resolveCode>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getResolveCodeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getResolveCodeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getResolveCodeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveCode>>> = ({
    signal,
  }) => resolveCode(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof resolveCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type ResolveCodeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof resolveCode>>
>;
export type ResolveCodeSuspenseQueryError = ErrorType<unknown>;

export function useResolveCodeSuspense<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveCodeSuspense<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveCodeSuspense<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary RAW 문자열 코드를 CLASSROOM / BOARD / QUIZ 로 분류한다
 */

export function useResolveCodeSuspense<
  TData = Awaited<ReturnType<typeof resolveCode>>,
  TError = ErrorType<unknown>,
>(
  params: ResolveCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getResolveCodeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const resolveEntryType = (
  enterCode: number,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyEnterCodeResult>(
    { url: `/enter-code/${enterCode}`, method: 'GET', signal },
    options,
  );
};

export const getResolveEntryTypeQueryKey = (enterCode: number) => {
  return [`/enter-code/${enterCode}`] as const;
};

export const getResolveEntryTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getResolveEntryTypeQueryKey(enterCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof resolveEntryType>>
  > = ({ signal }) => resolveEntryType(enterCode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: enterCode !== null && enterCode !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof resolveEntryType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ResolveEntryTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof resolveEntryType>>
>;
export type ResolveEntryTypeQueryError = ErrorType<unknown>;

export function useResolveEntryType<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveEntryType>>,
          TError,
          Awaited<ReturnType<typeof resolveEntryType>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveEntryType<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveEntryType>>,
          TError,
          Awaited<ReturnType<typeof resolveEntryType>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveEntryType<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useResolveEntryType<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getResolveEntryTypeQueryOptions(enterCode, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getResolveEntryTypeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getResolveEntryTypeQueryKey(enterCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof resolveEntryType>>
  > = ({ signal }) => resolveEntryType(enterCode, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof resolveEntryType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type ResolveEntryTypeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof resolveEntryType>>
>;
export type ResolveEntryTypeSuspenseQueryError = ErrorType<unknown>;

export function useResolveEntryTypeSuspense<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveEntryTypeSuspense<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveEntryTypeSuspense<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useResolveEntryTypeSuspense<
  TData = Awaited<ReturnType<typeof resolveEntryType>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof resolveEntryType>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getResolveEntryTypeSuspenseQueryOptions(
    enterCode,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
